import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProblemsAPI } from "../../../api/problems";

export default function ProblemsList() {
  const [problems, setProblems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    ProblemsAPI.list()
      .then(setProblems)
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">Problems</h1>

        <Link
          to="/helpdesk/problems/new"
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Create Problem
        </Link>
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      {problems.length === 0 ? (
        <div className="border rounded p-4 text-gray-500">
          No problems have been created yet.
        </div>
      ) : (
        <div className="space-y-2">
          {problems.map((p) => (
            <Link
              key={p.id}
              to={`/helpdesk/problems/${p.id}`}
              className="block border p-3 rounded hover:bg-gray-50"
            >
              <div className="font-semibold">{p.title}</div>
              <div className="text-sm text-gray-500">
                {p.status} • {p.ticket_count} tickets
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}